import React, {useState} from 'react';
import icon from '../../assets/excel.svg';
import spinner from 'common/assets/spinner.gif';
import styles from './styles.module.scss';

const ButtonExportToExcel = ({onClick}) => {
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    setLoading(true);
    try {
      await onClick();
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={styles.exportToExcelButton}
      disabled={loading}
    >
      <img src={loading ? spinner : icon} alt="i" className={styles.icon}/>
      <span>ייצוא לקובץ אקסל</span>
    </button>
  );
};

export default ButtonExportToExcel;